export default "__VITE_ASSET__chKe0xpx__"